"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { refreshAuthToken } from "@/app/_actions/refreshAuthToken";
import { useAuthClaimsStore } from "@/stores/useAuthClaimsStore";
import { useServicesStore } from "@/stores/useServicesStore";

// Refresh this many seconds before the access token expires so a long browsing
// session never silently drops to signed-out mid-page. Mirrors the legacy
// scheduled refresh (sg-frontend ClientsProvider) that fired ahead of expiry.
const REFRESH_BUFFER_SECONDS = 60;
export function useScheduledTokenRefresh() {
  const $ = _c(3);
  const exp = useAuthClaimsStore(_temp);
  let t0;
  let t1;
  if ($[0] !== exp) {
    t0 = () => {
      if (!exp) {
        return;
      }
      const nowSeconds = Date.now() / 1000;
      const delayMs = Math.max(0, (exp - REFRESH_BUFFER_SECONDS - nowSeconds) * 1000);
      const runRefresh = _temp2;
      const timer = window.setTimeout(() => void runRefresh(), delayMs);
      return () => window.clearTimeout(timer);
    };
    t1 = [exp];
    $[0] = exp;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}
async function _temp2() {
  const {
    success
  } = await refreshAuthToken();
  if (success) {
    await useServicesStore.getState().initClients();
  }
}
function _temp(state) {
  return state.claims?.exp;
}